import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database"

const firebaseConfig = {
    apiKey: "AIzaSyC2ebhtvUVdKsSYmnSKZkAOVZbsb7fzD6g",
    authDomain: "rabinandan-in.firebaseapp.com",
    databaseURL: "https://rabinandan-in-default-rtdb.firebaseio.com",
    projectId: "rabinandan-in",
    storageBucket: "rabinandan-in.appspot.com",
    messagingSenderId: "307275108643",
    appId: "1:307275108643:web:e64870ac4f189f1c08fc96",
    measurementId: "G-FZKTCPHW58"
};
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase
export const auth = getAuth(app);
export const db = getDatabase(app)

export default app;